import _ from 'underscore';

export default class {
    constructor(player) {
        this.player = player;
        this.wrapper = document.querySelector('#videos-most-pop-wrapper__player');
        this.scrollPlayed = false;
        this.checker = null;
    }

    playerPosition(playerEl) {
        var bodyRect = document.body.getBoundingClientRect();
        var playerRect = playerEl.getBoundingClientRect();
        return (playerRect.top - bodyRect.top);
    }

    scrollPosition() {
        var doc = document.documentElement;
        return {
            left: (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
            top: (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
        };
    }

    playerInView() {
        var difference = this.playerPosition(this.wrapper) - this.scrollPosition().top;
        var adjust = window.innerHeight > (this.player.getHeight() / 2) ? window.innerHeight : 100;
        var inView = (difference > -100 && difference < adjust);
        return this.player.play(inView);
    }

    on() {
        window.addEventListener('scroll', function () {
            _.throttle(this.playerInView(), 300);
        }.bind(this));
    }
}
